// extracted by mini-css-extract-plugin
export default {"row":"ContentFooter_row__9O-m3","placeHolderShimmer":"ContentFooter_placeHolderShimmer__ZBFvU"};